<template>
  <div>
    <div class="flex justify-between items-end">
      <div class="text-xs font-mono text-gray-600 mb-1">
        {{ created }}
      </div>
      <div class="flex bg-gray-200">
        <router-link
          :to="{ name: 'create-link', params: { linkId: link.id } }"
          class="flex items-center px-2 py-1 text-gray-600 hover:text-white hover:bg-blue-400"
        >
          <icon-copy title="Duplicate link" class="mr-1" />
          <span class="uppercase text-sm">Duplicate</span>
        </router-link>
        <router-link
          :to="{ name: 'edit-template', params: { link } }"
          class="flex items-center px-2 py-1 text-gray-600 hover:text-white hover:bg-blue-400"
        >
          <icon-plus-box title="Create template" class="mr-1" />
          <span class="uppercase text-sm">Create template</span>
        </router-link>
      </div>
    </div>
    <div class="bg-white leading-tight">
      <div class="flex px-2 py-3">
        <div class="w-1/2 px-2 flex items-center pr-4">
          <base-tooltip text="Copy URL to clipboard" class="mr-3">
            <button
              @click="copyLink"
              class="text-3xl text-gray-600 hover:text-blue-400"
            >
              <icon-link title="Copy URL" />
            </button>
          </base-tooltip>

          <div class="mr-4 break-all">
            {{ link.output_link }}
          </div>
        </div>
        <div class="w-1/6 px-2 text-center border-r border-gray-300">
          <span class="block text-gray-600">Campaign</span>
          {{ link.campaign.name }}
        </div>
        <div class="w-1/6 px-2 text-center border-r border-gray-300">
          <span class="block text-gray-600">Channel</span>
          {{ link.marketer_data.channel }}
        </div>
        <div class="w-1/6 px-2 text-center">
          <span class="block text-gray-600">Marketer</span>
          {{ link.marketer_data.marketer }}
        </div>
      </div>
      <base-tooltip :text="open ? 'Collapse link info' : 'Expand link info'">
        <button
          @click="toggleOpen"
          class="w-full text-gray-400 text-lg focus:outline-none hover:text-blue-400"
        >
          <icon-expand-down
            title="Expand link info"
            class="transform"
            :class="open ? 'rotate-180' : ''"
          />
        </button>
      </base-tooltip>
      <div v-if="open" class="mt-2 p-4 border-t border-gray-300">
        <div class="flex mb-3">
          <div class="w-1/5 px-2 text-center">
            <span class="block text-gray-600">Source</span>
            {{ link.marketer_data.source }}
          </div>
          <div class="w-1/5 px-2 text-center">
            <span class="block text-gray-600">Country</span>
            {{ link.marketer_data.country }}
          </div>
          <div class="w-1/5 px-2 text-center">
            <span class="block text-gray-600">Ad format</span>
            {{ link.marketer_data.adformat }}
          </div>
          <div class="w-1/5 px-2 text-center">
            <span class="block text-gray-600">Standard ad name</span>
            {{ link.marketer_data.std_adname }}
          </div>
          <div class="w-1/5 px-2 text-center">
            <span class="block text-gray-600">Marketer ad name</span>
            {{ link.marketer_data.marketer_adname }}
          </div>
        </div>
        <div class="flex flex-wrap">
          <div
            v-for="parameter in customParameters"
            :key="parameter.name"
            class="w-1/5 px-2 mb-3 text-center"
          >
            <span class="block text-gray-600">{{ parameter.name }}</span>
            {{ parameter.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { useFormattedDate } from '@/composables/useFormattedDate';

export default {
  props: {
    link: Object,
  },
  setup(props) {
    const open = ref(false);
    const toggleOpen = () => {
      open.value = !open.value;
    };
    const customParameters = computed(() =>
      Object.entries(props.link.client_data).map(([name, value]) => ({
        name,
        value,
      }))
    );
    const copyLink = () => {
      navigator.clipboard.writeText(this.link.output_link);
    };
    const created = useFormattedDate({
      date: props.link.created_at,
    });

    return {
      open,
      toggleOpen,
      copyLink,
      customParameters,
      created,
    };
  },
};
</script>
